import { QuestionnaireTemplateSection as Section, QuestionnaireTemplateSection } from "./questionnaire-template-section.model";
import { AbstractModel } from "../abstract-model";
import { MongoHelper } from "../../helpers/mongo-helper";

/**
 * A kérdőív típusa.
 */
export enum QuestionnaireType {
    /** Egy-kédéses kérdőív. */
    Notation = 0,
    /** Több kérdéses kérdőív. */
    List = 1
}

/**
 * Kérdőív-sablon osztálya.
 * Az ebben leírt kérdőív-sablonok alapján lehet kérdőíveket indítani.
 */
export class QuestionnaireTemplate extends AbstractModel {

    public static get collection() {
        if (Meteor.isServer)
            return MongoHelper.mongoDb.collection<QuestionnaireTemplate>('questionnaire-template');
        else
            throw new Meteor.Error("Collection is not available from  client code. Use the appropriate service classs instead.")
    }

    /****************** */
    /** Template fields */
    /****************** */

    /**
     * A kérdőív neve.
     * - kötelező
     * - hossza max. 100 karakter.
     * - kollekción belül egydinek kell lennie
     */
    name: string = "";

    /**
     * A sablon leírása.
     * - kötelező (lehet üres szöveg)
     * - hossza max. 500 karakter.
     */
    description?: string = "";

    /**
     * A kérdőív típusa.     *
     * Lehet egy kérdésből álló "jelőlés"/"notation" illetve egy vagy több kérdésből
     * álló "kérdéssor"/"questionList".
     * - kötelező (lehet 0)
     * - típusa: integer
     * - értéket csak a QuestionnaireType-ban meghatározottak közül vehet fel
     */
    type: QuestionnaireType = QuestionnaireType.List;

    /**
     * Mutatja, hogy a kérdőív időzítetten egyszer vagy többször tölthető-e ki.
     * Ha egyszer, akkor nem szabad a 'schedules' mező értékét figyelembe venni. A felhasználó
     * nem is adhat meg időzítést (modellben figyelni!).
     * - kötelező (lehet false)
     */
    repeatable?: boolean = false;

    /**
     * Egyszer kitölthető kérdőív esetén jelzi, hogy kötelező-e a kérdőív kitöltése.
     * - kötelező (lehet false)
     * - értéke csak false lehet, ha a repeadable értéke true
     */
    required?: boolean = false;

    /**
     * Megadja, hogy azonos sablonból származó, az időzítések során "összecsúszó" kitöltések
     * esetén a korábbi elkezdett kitöltés a kitöltendők listájában marad, vagy lezárt állapotúra
     * kell, hogy váltson.
     * - kötelező (lehet false)
     */
    cancelOverlapped?: boolean = false;

    /**
     * Megadja, hogy a megszakadt és már lezárt kitöltés adatai közül a teljesen kitöltött szakszok
     * adatai feldolgozhatók-e, vagy az egész megy a kukába.
     * - kötelező (lehet false)
     */
    cancelledUsable?: boolean = false;

    /**
     * A kérdőívben lévő kérdés-szekciók.
     * - kötelező
     * - legalább egy eleműnek kell lennie
     * - ha a típus 'Notation', akkor csak egyeleme lehet
     */
    sections: Section[] = [];

    /**
     * Az osztály konstruktora.
     * @param data 
     */
    constructor(data?: any) {
        super();
        this.init(data, this);
    }
}